// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-item {
    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
    border-radius: 4px;
    max-width: 85%;
    overflow-wrap: break-word;
    padding: 10px 10px;
    margin: 5px;
    min-width: 70%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.message-item__new-kb {
    position: relative; 
    border-radius: 50%;
    width: 2.2rem; 
    height: 2.2rem;
    cursor: pointer;
    line-height: 2.2rem;
    text-align: center; 
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
    background-color: aliceblue;
    font-weight: bold;
    font-size: 1.2rem;
    user-select: none;
    transition: transform 0.2s ease;
}

.message-item__author-name {
    font-size: small;
    font-weight: bold;
    width: 100%;
}

.message-item__author-name.client-message-type {
    text-align: right;
    border-radius: 50px;
    padding-right: .4rem;
    background: linear-gradient(to right,  rgba(65, 191, 255, 0), rgba(233, 248, 255, 0.5), rgb(144, 218, 255));
}

.message-item__author-name.operator-message-type {
    text-align: left;
    border-radius: 50px;
    padding-left: .4rem;
    background: linear-gradient(to right, rgb(144, 218, 255), rgba(233, 248, 255, 0.5), rgba(65, 191, 255, 0));
}

.system-message-item {
    margin-top: .5rem;
    margin-bottom: .5rem;
    font-size: 1.4rem;
    overflow-wrap: anywhere;
}

.contact-info-container {
    width: 3rem;
    float: right;
    margin-right: 1rem;
    margin-top: 5px;
}

.operator-message-type {
    float: right;
}

.client-message-type {
    float: left;
}

.chat-info-messageType {
    min-width: 100% !important;
    height: 2rem;
    background-color: rgba(185, 196, 196, 0.4);
    font-size: 1.6rem;
    margin-top: 2rem;
    display: inline-table;
}

.chat-info-message-info-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
}

.chat-info-messageType.chat-type-comment {
    background-color: rgba(156, 247, 171, 0.4);
}

.chat-info-messageType.chat-type-group {
    background-color: rgba(170, 156, 247, 0.4);
}

.chat-info-messageType.chat-type-mailing {
    background-color: rgba(247, 218, 156, 0.4);
}

.message-text {
    text-align: left;
    white-space: pre-wrap;
    padding: 0 14px;
}

.message-text div {
    font-size: 1.6rem !important;
}

.message-time {
    text-align: right;
    font-size: 1.4rem;
    margin-left: auto;
}

.contact-name {
    font-size: 12px;
}

.contact-avatar img{
    width: 40px;
    border-radius: 50%;
}

.message-item__media {
    width: 300px;
    height: 200px;
    max-width: 100%;
}

.message-item__image {
    max-width: 100%;
    min-height: 5rem;
    max-height: 15rem;
}

.message-item__file_link {
    cursor: pointer;
    text-align: left;
    font-size: medium;
    margin-left: 1rem;
}

.location_iframe {
    width: -webkit-fill-available;
    height: 450px;
}

.rotate--icon {
    position: relative;
    display: none;
}

.rotate--image {
    position: relative;
}

.rotate--image:hover .rotate--icon {
    display: block;
}

.rotate--icon-image{
    position: absolute;
    left: 0;
    top: 0;
}

#content-type__label {
    font-family: "Material Icons" !important;
}

.operator-button-display {
    background-color: #777777;
    color: #FFFFFF;
    border: solid 1px #FFFFFF;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

audio {
    width: -webkit-fill-available;
}

.wmde-markdown {
    white-space: initial;
    background-color: initial;
}

.message-item__chat-messenger-img {
    width: 2rem;
    height: 2rem;
    vertical-align: middle;
    display: inline-block;
}

.message-item__flex-container {
    display: flex;
    justify-content: center;
    gap: 10px;
}

.comment-message {
    background-color: #d9ffcb8a;
}

.failed-message {
    border: 1px solid red;
}

.retry-send-button {
    cursor: pointer;
    position: absolute;
    right: 2rem;
    z-index: 1;
}

.message-footer {
    display: flex;
    justify-content: space-between; 
    align-items: center;
    margin-top: 6px;
    padding: 0 5px;
}

.message-footer i {
    font-size: 1.4rem;
}

.message-footer__left-side {
    display: flex;
    align-items: center;
    gap: 8px; 
}

.deleted-text {
    font-style: italic;
}

.deleted-text .content {
    text-decoration: line-through;
}`, "",{"version":3,"sources":["webpack://./src/app/chats-panel/MessageItem/MessageItem.css"],"names":[],"mappings":"AAAA;IACI,uGAAuG;IACvG,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;IACrC,2BAA2B;IAC3B,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,2GAA2G;AAC/G;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,0GAA0G;AAC9G;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;AACV;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":[".message-item {\r\n    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);\r\n    border-radius: 4px;\r\n    max-width: 85%;\r\n    overflow-wrap: break-word;\r\n    padding: 10px 10px;\r\n    margin: 5px;\r\n    min-width: 70%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n}\r\n\r\n.message-item__new-kb {\r\n    position: relative; \r\n    border-radius: 50%;\r\n    width: 2.2rem; \r\n    height: 2.2rem;\r\n    cursor: pointer;\r\n    line-height: 2.2rem;\r\n    text-align: center; \r\n    box-shadow: 0 1px 3px rgba(0,0,0,0.2);\r\n    background-color: aliceblue;\r\n    font-weight: bold;\r\n    font-size: 1.2rem;\r\n    user-select: none;\r\n    transition: transform 0.2s ease;\r\n}\r\n\r\n.message-item__author-name {\r\n    font-size: small;\r\n    font-weight: bold;\r\n    width: 100%;\r\n}\r\n\r\n.message-item__author-name.client-message-type {\r\n    text-align: right;\r\n    border-radius: 50px;\r\n    padding-right: .4rem;\r\n    background: linear-gradient(to right,  rgba(65, 191, 255, 0), rgba(233, 248, 255, 0.5), rgb(144, 218, 255));\r\n}\r\n\r\n.message-item__author-name.operator-message-type {\r\n    text-align: left;\r\n    border-radius: 50px;\r\n    padding-left: .4rem;\r\n    background: linear-gradient(to right, rgb(144, 218, 255), rgba(233, 248, 255, 0.5), rgba(65, 191, 255, 0));\r\n}\r\n\r\n.system-message-item {\r\n    margin-top: .5rem;\r\n    margin-bottom: .5rem;\r\n    font-size: 1.4rem;\r\n    overflow-wrap: anywhere;\r\n}\r\n\r\n.contact-info-container {\r\n    width: 3rem;\r\n    float: right;\r\n    margin-right: 1rem;\r\n    margin-top: 5px;\r\n}\r\n\r\n.operator-message-type {\r\n    float: right;\r\n}\r\n\r\n.client-message-type {\r\n    float: left;\r\n}\r\n\r\n.chat-info-messageType {\r\n    min-width: 100% !important;\r\n    height: 2rem;\r\n    background-color: rgba(185, 196, 196, 0.4);\r\n    font-size: 1.6rem;\r\n    margin-top: 2rem;\r\n    display: inline-table;\r\n}\r\n\r\n.chat-info-message-info-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 1rem;\r\n}\r\n\r\n.chat-info-messageType.chat-type-comment {\r\n    background-color: rgba(156, 247, 171, 0.4);\r\n}\r\n\r\n.chat-info-messageType.chat-type-group {\r\n    background-color: rgba(170, 156, 247, 0.4);\r\n}\r\n\r\n.chat-info-messageType.chat-type-mailing {\r\n    background-color: rgba(247, 218, 156, 0.4);\r\n}\r\n\r\n.message-text {\r\n    text-align: left;\r\n    white-space: pre-wrap;\r\n    padding: 0 14px;\r\n}\r\n\r\n.message-text div {\r\n    font-size: 1.6rem !important;\r\n}\r\n\r\n.message-time {\r\n    text-align: right;\r\n    font-size: 1.4rem;\r\n    margin-left: auto;\r\n}\r\n\r\n.contact-name {\r\n    font-size: 12px;\r\n}\r\n\r\n.contact-avatar img{\r\n    width: 40px;\r\n    border-radius: 50%;\r\n}\r\n\r\n.message-item__media {\r\n    width: 300px;\r\n    height: 200px;\r\n    max-width: 100%;\r\n}\r\n\r\n.message-item__image {\r\n    max-width: 100%;\r\n    min-height: 5rem;\r\n    max-height: 15rem;\r\n}\r\n\r\n.message-item__file_link {\r\n    cursor: pointer;\r\n    text-align: left;\r\n    font-size: medium;\r\n    margin-left: 1rem;\r\n}\r\n\r\n.location_iframe {\r\n    width: -webkit-fill-available;\r\n    height: 450px;\r\n}\r\n\r\n.rotate--icon {\r\n    position: relative;\r\n    display: none;\r\n}\r\n\r\n.rotate--image {\r\n    position: relative;\r\n}\r\n\r\n.rotate--image:hover .rotate--icon {\r\n    display: block;\r\n}\r\n\r\n.rotate--icon-image{\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n}\r\n\r\n#content-type__label {\r\n    font-family: \"Material Icons\" !important;\r\n}\r\n\r\n.operator-button-display {\r\n    background-color: #777777;\r\n    color: #FFFFFF;\r\n    border: solid 1px #FFFFFF;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\naudio {\r\n    width: -webkit-fill-available;\r\n}\r\n\r\n.wmde-markdown {\r\n    white-space: initial;\r\n    background-color: initial;\r\n}\r\n\r\n.message-item__chat-messenger-img {\r\n    width: 2rem;\r\n    height: 2rem;\r\n    vertical-align: middle;\r\n    display: inline-block;\r\n}\r\n\r\n.message-item__flex-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 10px;\r\n}\r\n\r\n.comment-message {\r\n    background-color: #d9ffcb8a;\r\n}\r\n\r\n.failed-message {\r\n    border: 1px solid red;\r\n}\r\n\r\n.retry-send-button {\r\n    cursor: pointer;\r\n    position: absolute;\r\n    right: 2rem;\r\n    z-index: 1;\r\n}\r\n\r\n.message-footer {\r\n    display: flex;\r\n    justify-content: space-between; \r\n    align-items: center;\r\n    margin-top: 6px;\r\n    padding: 0 5px;\r\n}\r\n\r\n.message-footer i {\r\n    font-size: 1.4rem;\r\n}\r\n\r\n.message-footer__left-side {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px; \r\n}\r\n\r\n.deleted-text {\r\n    font-style: italic;\r\n}\r\n\r\n.deleted-text .content {\r\n    text-decoration: line-through;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
